<template>
  <div class="tp-item" :class="{active: selectedId === itemObj[valueKey]}">
    <div class="img-container" v-if="itemObj.thumb_path">
      <img :src="itemObj.thumb_path"/>
    </div>
    <div class="img-container" v-else-if="Object.keys(itemObj).findIndex(obj=> obj=='ruler_id') != -1">
       <img src="../assets/img/hotspot_ruler.png"/>
    </div>
    <div class="icon-container" v-else>
      <a-icon style="fontSize: 20px" :type="itemObj.type ? iconType[itemObj.type] :iconType.scene" />
    </div>
    <div class="list-name">{{itemObj[titleKey]}}</div>
  </div>
</template>


<script>
export default {
  props: {
    itemObj: {
      required: true,
      type: Object,
    },
    selectedId: {
      default: "",
      type: String,
    },
    valueKey: {
      default: "paster_id",
      type: String,
    },
    titleKey: {
      default: "title",
      type: String,
    }
  },
  data() {
    return {
      iconType: {
        word: "align-left", //  "T"
        pic: "picture", // 圖
        pictext: "snippets",
        video: "play-circle", //視
        audio: "sound", // 音
        link: "global", // 鏈
        scene: "pic-center", // 場
      },
    };
  },
};
</script>

<style lang="less" scoped>
.tp-item {
  min-width: 47px;
  max-width: 47px;
  height: 47px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(90, 90, 90, 1);
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // flex-wrap: wrap;
  .icon-container {
    text-align: center;
    padding-top: 5px;
    width: 100%;
  }
  .list-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    text-align: center;
    width: 100%;
  }
}
.active {
  border: 2px solid #ffffff;
}
  .img-container{
    max-width: 28px;
    max-height: 28px;
    padding: 2px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin: 0 auto;
    img{
      max-width: 100%;
      max-height: 100%;
    }
  }
  .ruler-img{
    max-width: 26px;
    max-height: 26px;
  }
</style>
